import * as React from 'react';

const Loading = () => (
    <div className='dsq-loading-container'>
        <div className='dsq-spinner' />
    </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./frontend/src/ts/components/Loading.tsx